import {TRUSTPILOT_LABELS} from './constants'

export const getTrustScoreLabel = (score: number) => {
  if (score < 1.0 || score > 5.0) return TRUSTPILOT_LABELS.invalidScore
  if (score >= 4.3) return TRUSTPILOT_LABELS.excellent
  if (score >= 3.8) return TRUSTPILOT_LABELS.great
  if (score >= 2.8) return TRUSTPILOT_LABELS.average
  if (score >= 1.8) return TRUSTPILOT_LABELS.poor
  return TRUSTPILOT_LABELS.bad
}

export const getRateURL = (stars: number) =>
  `https://images-static.trustpilot.com/api/stars/${stars}/star.svg`
